import { action, makeObservable, observable } from 'mobx';
import { Injectable } from './service.base';
import parse from 'html-react-parser';
import { ModelUnityDocuments, ModelUnityDocument } from '~/models/model.unity.documents';
import { UnityDocumentType } from '~/views/enums';

@Injectable()
export class PrivacyPolicyDialogService {
    @observable public open = false;
    @observable public documentText: any;

    constructor() {
        makeObservable(this);
    }

    @action
    handleOpen = (e: any, unityDocuments: ModelUnityDocuments, documentType: UnityDocumentType) => {
        e.preventDefault();
        this.open = true;
        let document: ModelUnityDocument | undefined;

        switch (documentType) {
            case UnityDocumentType.privacy:
                document = unityDocuments.documents.find(item => item.consentName === 'Unity Privacy Policy');
                break;
            case UnityDocumentType.terms:
                document = unityDocuments.documents.find(item => item.consentName === 'Unity Terms and Conditions');
                break;
        }

        if (document) {
            this.documentText = parse(document.consentContent);
        }
    };

    @action
    handleClose = () => {
        this.open = false;
    };
}
